export default __webpack_public_path__ + "static/media/Pattern3.67131926.png";